@if (url) {
  <div
    class="embed-modal-backdrop"
    [class.embed-modal-backdrop--closing]="closing()"
    (click)="close()"
  >
    <div
      class="embed-modal"
      [class.embed-modal--closing]="closing()"
      (click)="$event.stopPropagation()"
    >
      <div class="embed-modal__header">
        <span class="embed-modal__title">{{ title }}</span>
        <button class="embed-modal__close" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="embed-modal__body">
        @if (!loaded()) {
          <div class="embed-modal__loader">
            <div class="embed-modal__spinner"></div>
          </div>
        }
        <iframe
          class="embed-modal__frame"
          [class.embed-modal__frame--hidden]="!loaded()"
          [src]="url"
          frameborder="0"
          (load)="onFrameLoad()"
        ></iframe>
      </div>
    </div>
  </div>
}
